<template>
  <div style>
    <user-token-site-info :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <div class="report-detail-switch-wrap" :style="referer == 'list' ? 'width:440px' : ''">
      <div class="report-detail-switch-background" :class="report_switch == 'left' ? 'left' : 'right'"></div>
      <div class="report-detail-switch-left" @click="switchReport('left')"><font-awesome-icon :icon="['fal', 'user']" style="margin-right: 7px;" />個別で選択</div>
      <div class="report-detail-switch-right" @click="switchReport('right')">
        <font-awesome-icon :icon="['fal', 'list']" style="margin-right: 7px;" />
        {{ referer == "list" ? "スプレッドシートから一括インポート" : "リストから選択" }}
      </div>
    </div>
    <div class="report-detail-subtitle">
      <span v-if="report_switch == 'left'">インフルエンサー選択</span>
      <span v-else>{{ referer == "list" ? "スプレッドシートのユーザー名/URL列を貼り付け" : "リスト選択" }}</span>
    </div>
    <div class="request-pr-form-parts search" style="flex-flow:column;" v-if="report_switch == 'left'">
      <el-input
        :placeholder="sns_type == 'instagram' || sns_type == 'tiktok' ? 'ユーザー名を入力してください' : 'チャンネル名を入力してください'"
        v-model="report.new_influencer"
        @input="suggestInfluencer()"
        @focus="suggest_show = true"
        @blur="suggest_on ? '' : (suggest_show = false) & (suggest_hover = -1)"
        @keydown.up.native="suggestHover('up', 'influencer-box')"
        @keydown.down.native="suggestHover('down', 'influencer-box')"
        @keypress.enter.native="suggest_hover > -1 ? suggestClickEnter() : suggestClick(report.new_influencer)"
      ></el-input>
      <div class="request-pr-form-suggest" id="influencer-box" v-if="suggest_show && report.new_influencer != ''" :class="suggest_influencer.length > 7 ? 'scroll' : ''">
        <div
          class="request-pr-form-suggest-box"
          v-for="(suggest, index) in suggest_influencer"
          :key="suggest.id"
          v-show="report.new_influencer != '' || suggest_loading"
          :class="suggest_hover == index ? 'hover' : ''"
          @click="suggestClick(suggest.account_name)"
          @mouseover="suggest_on = true"
          @mouseleave="suggest_on = false"
        >
          <el-image :src="suggest.profile_picture_url" class="request-pr-form-suggest-image">
            <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
          </el-image>
          <div>
            <div>
              {{ suggest.account_name }}
              <img src="../../assets/badge.png" style="width:10px; height:10px; margin-left:3px" v-show="suggest.badge" />
              <font-awesome-icon :icon="['fas', 'check-circle']" v-show="suggest.verified && sns_type == 'tiktok'" class="tt-badge" />
              <font-awesome-icon :icon="['fas', 'badge-check']" v-show="suggest.verified && sns_type == 'twitter'" class="tw-badge" />
            </div>
            <div style="color:#aaa">{{ suggest.name }}</div>
          </div>
        </div>
        <div class="request-pr-form-suggest-box nolist" v-if="suggest_influencer.length == 0 && report.new_influencer && !suggest_loading">{{ siteName }} に登録されていません</div>
      </div>
    </div>
    <div class="request-pr-form-parts search" style="flex-flow:column;" v-if="report_switch == 'right' && referer != 'list'">
      <el-input placeholder="リストを検索" v-model="report.list_value" @input="suggestList()" clearable class="report-create-list-search"></el-input>
      <div class="request-pr-form-parts" style="padding:0 0 20px 0; font-size:11px; color:#999;" v-if="check_list.length">
        <div>{{ check_list.length }}件のリスト/{{ influencer_list.length }}名のインフルエンサーが選択されています</div>
        <div class="flex-space"></div>
        <div @click="$emit('update:checkList', [])" class="router-link">全てのリストの選択を解除</div>
      </div>
      <div class="report-create-list-wrap">
        <div v-for="suggest in suggest_list" :key="suggest.id" class="report-create-list">
          <div class="data-table-th-checkbox">
            <input type="checkbox" class="checkbox-original" @change="suggestListClick()" v-model="check_list" :value="suggest.list_id" :id="suggest.list_id + 'checkbox'" />
            <label class="checkbox_inner" :for="suggest.list_id + 'checkbox'"> </label>
          </div>
          <div>{{ suggest.list_name }}</div>
          <div class="flex-space"></div>
          <div style="margin-right:20px">{{ suggest.influencer_num }}</div>
        </div>
      </div>
    </div>
    <div class="request-pr-form-parts search" style="flex-flow:column;" v-if="report_switch == 'right' && referer == 'list'">
      <el-input class="influencer-suggest-textarea" :value="influencer_bulk" @input="inputInfluencerBulk($event)" type="textarea" :rows="15"></el-input>
      <div class="influencer-suggest-textarea-placeholder" v-if="!influencer_bulk">
        <span v-if="sns_type == 'instagram'">
          ユーザー名もしくはユーザーURLを1行ごとに入力してください
          <br />
          <br />(例) <br />https://www.instagram.com/kimkardashian/ <br />https://www.instagram.com/justinbieber/ <br />https://www.instagram.com/cristiano/ <br />... <br />kimkardashian
          <br />justinbieber <br />cristiano <br />...
          <br />
        </span>
        <span v-if="sns_type == 'youtube'">
          チャンネルのURLを1行ごとに入力してください
          <br />
          <br />(例) <br />https://www.youtube.com/user/0214mex <br />https://www.youtube.com/user/HikakinTV <br />...<br />https://www.youtube.com/channel/UCutJqz56653xV2wwSvut_hQ
          <br />https://www.youtube.com/channel/UCaminwG9MTO4sLYeC3s6udA <br />...<br />https://www.youtube.com/@hajimesyacho<br />https://www.youtube.com/%EF%BC%A0HikakinTV
          <br />
        </span>
        <span v-if="sns_type == 'tiktok'">
          ユーザー名もしくはユーザーURLを1行ごとに入力してください
          <br />
          <br />(例) <br />https://www.tiktok.com/@kageihina <br />https://www.tiktok.com/@junya1gou <br />https://www.tiktok.com/@bayashi.tiktok <br />... <br />kageihina <br />junya1gou
          <br />bayashi.tiktok <br />...
          <br />
        </span>
        <span v-if="sns_type == 'twitter'">
          ユーザー名もしくはユーザーURLを1行ごとに入力してください
          <br />
          <br />(例) <br />https://x.com/elonmusk <br />https://x.com/MINAMI373HAMABE <br />https://x.com/NANAO1028 <br />... <br />elonmusk <br />MINAMI373HAMABE
          <br />NANAO1028 <br />...
          <br />
        </span>
      </div>
    </div>
    <div class="request-pr-form-parts" style="font-size:11px; color:#999;" v-if="influencer_list.length > 0 && report_switch == 'left'">
      <div>{{ influencer_list.length }}名のインフルエンサーが選択されています</div>
      <div class="flex-space"></div>
      <div @click="$emit('update:influencer_list', [])" class="router-link">全員の選択を解除</div>
    </div>
    <div class="request-pr-form-parts" v-if="report_switch == 'left'">
      <div class="request-pr-form-add">
        <div class="request-pr-form-add-box" v-for="(influencer, influencer_index) in influencer_list" :key="influencer.id">
          <el-image :src="influencer.profile_picture_url" class="request-pr-form-suggest-image">
            <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
          </el-image>
          <div>
            <div>
              {{ influencer.account_name }}
              <img src="../../assets/badge.png" style="width:10px; height:10px; margin-left:3px" v-show="influencer.badge" />
              <font-awesome-icon :icon="['fas', 'check-circle']" v-show="influencer.verified && sns_type == 'tiktok'" class="tt-badge" />
              <font-awesome-icon :icon="['fas', 'badge-check']" v-show="influencer.verified == '1' && sns_type == 'twitter'" class="tw-badge" />
            </div>
            <div style="color:#aaa">{{ influencer.name }}</div>
          </div>
          <div class="flex-space"></div>
          <div>
            <font-awesome-icon icon="times" @click="cancelInfluencer(influencer_index)" style="cursor:pointer; padding:5px; font-size:14px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;

const suggestInfluencerAPI = root + "/api/report/suggest_influencer";
const suggestListAPI = root + "/api/report/suggest_list";
const confirmInfluencerAPI = root + "/api/report/confirm_influencer";
const confirmListInfluencerAPI = root + "/api/report/confirm_list";
import UserTokenSiteInfo from "@/components/oem/UserTokenSiteInfo.vue";

export default {
  name: "influencerSuggest",
  props: ["sns_type", "referer", "influencer_list", "influencer_bulk", "report_switch", "checkList"],
  components: {
    UserTokenSiteInfo,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      report: {
        influencer: [],
        new_influencer: "",
        list_value: "",
      },
      influencer_index: "",
      suggest_influencer: [],
      suggest_list: [],
      suggest_loading: false,
      suggest_show: false,
      suggest_hover: -1,
      suggest_on: false,
      check_list: [],
      requestId: +new Date(),
      siteName: 'REECH DATABASE',
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
  },
  created() {},
  mounted() {
    this.suggestList();
    this.check_list = this.checkList;
  },
  methods: {
    switchReport(report_switch) {
      if (report_switch == "left") {
        this.$emit("update:checkList", []);
        this.$emit("update:influencer_list", []);
        this.$emit("update:report_switch", "left");
      } else if (report_switch == "right") {
        this.$emit("update:influencer_list", []);
        this.$emit("update:report_switch", "right");
      }
    },
    suggestInfluencer() {
      if (this.report.new_influencer != "") {
        this.suggest_loading = true;
        this.suggest_show = true;
        this.suggest_hover = -1;
        this.axios.cancel(this.requestId);
        this.requestId += 1;
        this.axios
          .get(suggestInfluencerAPI, {
            requestId: this.requestId,
            params: {
              token: this.token,
              sns_type: this.sns_type,
              influencer: this.report.new_influencer,
            },
          })
          .then((response) => {
            this.suggest_influencer = response.data;
            this.suggest_loading = false;
          });
      } else {
        this.suggest_influencer = [];
      }
    },
    suggestHover(type, position) {
      if (type == "up") {
        if (this.suggest_hover == -1) {
          this.suggest_hover += 0;
        } else {
          this.suggest_hover -= 1;
        }
      } else if (type == "down") {
        if (position == "influencer-box") {
          if (this.suggest_hover == this.suggest_influencer.length - 1) {
            this.suggest_hover += 0;
          } else {
            this.suggest_hover += 1;
          }
        } else if (position == "list-box") {
          if (this.suggest_hover == this.suggest_list.length - 1) {
            this.suggest_hover += 0;
          } else {
            this.suggest_hover += 1;
          }
        } else if (position == "mention-box") {
          if (this.suggest_hover == this.suggest_tag.length - 1) {
            this.suggest_hover += 0;
          } else {
            this.suggest_hover += 1;
          }
        }
      }
      if (position == "list-box") {
        var suggest_position = 51;
      } else {
        suggest_position = 59;
      }
      var target = document.getElementById(position);
      target.scrollTop = (this.suggest_hover - 5) * suggest_position;
    },
    suggestClick(account_name) {
      this.report.new_influencer = "";
      this.confirmInfluencer(account_name);
      this.suggest_show = false;
      this.suggest_on = false;
      this.suggest_hover = -1;
    },
    suggestClickEnter() {
      this.report.new_influencer = "";
      this.confirmInfluencer(this.suggest_influencer[this.suggest_hover].account_name);
      this.suggest_show = false;
      this.suggest_on = false;
      this.suggest_hover = -1;
    },
    suggestListClick() {
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("sns_type", this.sns_type);
      params.append("list_id", JSON.stringify(this.check_list));
      this.axios
        .post(confirmListInfluencerAPI, params)
        .then((response) => {
          this.$emit("update:influencer_list", response.data.influencer_list);
          this.$emit("update:checkList", response.data.checkedList);
          this.suggest_loading = false;
        })
        .catch(() => {});
      // this.suggest_show = false;
      // this.suggest_on = false;
      // this.suggest_hover = -1;
    },
    suggestList() {
      this.suggest_loading = true;
      this.suggest_show = true;
      this.suggest_hover = -1;
      this.axios
        .get(suggestListAPI, {
          params: {
            token: this.token,
            sns_type: this.sns_type,
            list_name: this.report.list_value,
          },
        })
        .then((response) => {
          this.suggest_list = response.data;
          this.suggest_loading = false;
        });
    },
    confirmInfluencer(account_name) {
      if (account_name != "") {
        var influencer_list = this.influencer_list;
        this.axios
          .get(confirmInfluencerAPI, {
            params: {
              token: this.token,
              sns_type: this.sns_type,
              influencer: account_name,
            },
          })
          .then((response) => {
            if (response.data == "NG") {
              this.$message({
                type: "error",
                offset: 7,
                showClose: true,
                message: "「" + account_name + "」は" + this.siteName + " に登録されていないインフルエンサーです",
              });
            } else {
              //重複チェック
              var existCheck = false;
              for (let i = 0; i < this.influencer_list.length; i++) {
                if (this.influencer_list[i].account_name == account_name) {
                  existCheck = true;
                  break;
                }
              }
              for (let ii = 0; ii < this.report.influencer.length; ii++) {
                if (this.report.influencer[ii].account_name == account_name) {
                  existCheck = true;
                  break;
                }
              }
              if (existCheck == true) {
                this.$message({
                  type: "error",
                  offset: 7,
                  showClose: true,
                  message: "「" + account_name + "」は既に選択されています",
                });
              } else {
                influencer_list.push(response.data);
                this.$emit("update:influencer_list", influencer_list);
                if (this.referer == "list") {
                  var id_list = [];
                  for (let i = 0; i < this.influencer_list.length; i++) {
                    if (this.sns_type == "instagram") {
                      id_list.push(this.influencer_list[i].ig_id);
                    } else if (this.sns_type == "youtube") {
                      id_list.push(this.influencer_list[i].channel_id);
                    } else if (this.sns_type == "tiktok") {
                      id_list.push(this.influencer_list[i].tt_id);
                    } else if (this.sns_type == "twitter") {
                      id_list.push(this.influencer_list[i].tw_id);
                    }
                  }
                  this.$emit("syncInfluencerList", id_list);
                }
              }
            }
          });
      }
    },
    cancelInfluencer(index) {
      this.influencer_list.splice(index, 1);
    },
    inputInfluencerBulk($event) {
      this.$emit("update:influencer_bulk", $event);
      this.$emit("update:report_switch", "right");
    },
    updateSiteInfo({siteName}) {
      this.siteName = siteName;
    },
  },
  watch: {},
  filters: {},
};
</script>
